import { VictoryPointStateReader } from '@colonist/game-base-types';
export function getPublicVictoryPoints(playerValidator) {
    return VictoryPointStateReader.totalPublicVictoryPoints(playerValidator.victoryPointsState);
}
